import { z } from "zod";
export const dmaModelParameterMetadataDtoSchema = z.object({
    rawName: z.string(),
    name: z.string(),
    unit: z.string(),
});
